import { render, staticRenderFns } from "./main-layout.vue?vue&type=template&id=59453ebe&"
import script from "./main-layout.vue?vue&type=script&lang=js&"
export * from "./main-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports